import { render } from "./CustomRouterLink.vue?vue&type=template&id=66b4ae38"
import script from "./CustomRouterLink.vue?vue&type=script&lang=js"
export * from "./CustomRouterLink.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__